<button
  class="source-item"
  [ngClass]="{ 'source-item--active': isActive() }"
  (click)="onItemClicked()"
>
  <unis-icon
    font="light"
    [icon]="iconName()"
  />
  <span>{{ name() }}</span>
</button>
